let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '提现订单编号',
        props: 'cashOutNo',
        minWidth: 200,
    },
    {
        label: '提现金额',
        props: 'applyMoney',
        minWidth: 200,
    },
    {
        label: '提现时间',
        props: 'applyTime',
        minWidth: 200,
    },
    {
        label: '提现申请人',
        props: 'applyBy',
        minWidth: 200,
    },
    {
        label: '提现状态',
        props: 'chashOutStatusName',
        minWidth: 200,
    },
    {
        label: '成功付款时间',
        props: 'chashOutFinshTime',
        minWidth: 200,
    },
    {
        label: '银行卡尾号',
        props: 'applyBankCard',
        minWidth: 200,
    }
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '财务管理'
},
{
    type: 'title',
    name: '提现管理'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
};

// 列表-表格属性
pageConfig.detailTableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileModelDetail',
};

// 路由
pageConfig.listRouter = 'withdrawalList';

pageConfig.detailRouter = 'accountsReviewDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '财务管理'
},
{
    type: 'router',
    name: '提现管理',
    router: 'withdrawalList'
},
{
    type: 'title',
    name: '审核详情'
}];

pageConfig.formRules = {
    applyMoney: [{
        required: true,
        message: '请填写提现金额',
        trigger: 'blur'
    }],
};



export default pageConfig;